import axios from '@/core/http'

const fetchIndustries = () => {
  return axios.get('sources/industries/').then(res => res.data)
}

export { fetchIndustries }
